import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import { BUTTON_SHADOW_COLOR, PRIMARY_COLOR } from '../constants';
import { lighten } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: PRIMARY_COLOR,
    borderRadius: '100vh',
    color: 'white',
    fontWeight: 'bold',
    transition: 'all 250ms',
    borderBottom: `5px solid ${BUTTON_SHADOW_COLOR}`,
    '&:hover': {
      color: 'white',
      backgroundColor: lighten(PRIMARY_COLOR, 0.1),
    },
    '&:active': {
      borderBottom: `2px solid ${BUTTON_SHADOW_COLOR}`,
      marginTop: 3,
    },
  },
}));

const rightArrowStyles = makeStyles(() => ({
  label: {
    position: 'relative',
  },
  endIcon: {
    right: 16,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
  },
}));

const ServiceButton = ({ children, classes, rightArrow, ...other }) => {
  const rightArrowClasses = rightArrowStyles();
  const buttonClasses = useStyles({ classes });
  const rootClasses = rightArrow
    ? { ...buttonClasses, ...rightArrowClasses }
    : buttonClasses;
  return (
    <Button
      classes={rootClasses}
      disableRipple
      endIcon={rightArrow && <ChevronRightIcon />}
      {...other}
    >
      {children}
    </Button>
  );
};

export default ServiceButton;
